module.exports = __webpack_public_path__ + "images/directory/featured-hero/corrello@2x.35df1126d226ea818684.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/featured-hero/corrello@2x.png
// module id = 0KrA
// module chunks = 2